module.exports = __webpack_public_path__ + "img/next_point_end.7c44aa42.svg";